export default "__VITE_ASSET__Cwtq6LyA__"